import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Flex,
  Button,
  Text,
  Box,
  Checkbox,
  CheckboxGroup,
} from "@chakra-ui/react";
import { useCallback, useState } from "react";

import TagInput from "./TagInput";

interface FilterModalProps {
  isOpen: boolean;
  collocatePos: string[];
  filters: string[];
  onClose: () => void;
  onSearch: ({
    filters,
    collocatePos,
  }: {
    filters: string[];
    collocatePos: string[];
  }) => void;
}

const FilterModal = ({
  isOpen,
  collocatePos,
  filters,
  onClose,
  onSearch,
}: FilterModalProps) => {
  const [search, setSearch] = useState<string[]>(filters);
  const [part, setPart] = useState<(string | number)[]>(collocatePos);

  const [value, setValue] = useState("");

  const handleApply = useCallback(() => {
    const filters = !!value ? [...search, value] : search;
    onSearch({ filters, collocatePos: part as string[] });
    onClose();
  }, [onClose, onSearch, part, search, value]);

  const handleClear = useCallback(() => {
    setSearch([]);
    setPart([]);
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody py="2rem">
          <Text color="grayTxt" mb="1rem">
            Filter by Collocate
          </Text>
          <Box mb="2rem">
            <TagInput
              tags={search}
              value={value}
              onChange={setSearch}
              onSetValue={setValue}
            />
          </Box>
          <Text color="grayTxt" mb="1rem">
            Filter by Part of Speech (POS)
          </Text>
          <CheckboxGroup value={part} onChange={(value) => setPart(value)}>
            <Flex alignItems="flex-end" mb="1rem">
              <Box flex="1">
                <Checkbox colorScheme="second" value="n">
                  noun
                </Checkbox>
              </Box>
              <Box flex="1">
                <Checkbox colorScheme="second" value="j">
                  adjective
                </Checkbox>
              </Box>
            </Flex>
            <Flex alignItems="flex-end" mb="1rem">
              <Box flex="1">
                <Checkbox colorScheme="second" value="v">
                  verb
                </Checkbox>
              </Box>
              <Box flex="1">
                <Checkbox colorScheme="second" value="r">
                  adverb
                </Checkbox>
              </Box>
            </Flex>
            <Flex alignItems="flex-end" mb="1rem">
              <Box flex="1">
                <Checkbox colorScheme="second" value="i">
                  preposition
                </Checkbox>
              </Box>
            </Flex>
          </CheckboxGroup>
        </ModalBody>

        <ModalFooter>
          <Flex w="100%" alignItems="center" justifyContent="space-around">
            <Button
              width="140px"
              colorScheme="lightPrimary"
              variant="outline"
              onClick={handleClear}
            >
              Clear All
            </Button>
            <Button
              width="140px"
              variant="solid"
              colorScheme="lightPrimary"
              onClick={handleApply}
            >
              Apply
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FilterModal;
